import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import configureStore from './store';

import ImportsList from './imports';

export default function ImporterIndex({
  aggregateView,
  availableDatabases,
  currentUser,
  databaseId,
  databaseMembers,
  paths
}) {
  const store = configureStore({
    paths: paths,
    query: {
      importPage: 1,
    },
    search: {
      imports: [],
      isFetching: true,
      meta: {
        allIds: [],
        currentPage: 0,
        pageSize: 25,
        totalCount: 0,
        totalPages: 0
      }
    },
    static: {
      aggregateView: aggregateView,
      availableDatabases: availableDatabases,
      currentUser: currentUser,
      databaseId: databaseId,
      databaseMembers: databaseMembers
    }
  });

  return (
    <Provider store={store}>
      <ImportsList />
    </Provider>
  );
}

ImporterIndex.propTypes = {
  aggregateView: PropTypes.bool.isRequired,
  availableDatabases: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  databaseId: PropTypes.number,
  databaseMembers: PropTypes.array.isRequired,
  paths: PropTypes.object
};
